import { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Copy, Check, QrCode, LinkIcon, Download } from "lucide-react";
import { toast } from "sonner";

export function QRBox({ url, label, testid }) {
  const [view, setView] = useState("qr");
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    toast.success("Link disalin / Link copied");
    setTimeout(() => setCopied(false), 2000);
  };

  const downloadQR = () => {
    const canvas = document.querySelector(`#qr-${testid} canvas`);
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `${testid || "qr"}.png`;
    a.click();
  };

  return (
    <div className="bg-ink rounded-sm p-5" data-testid={testid}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-brass text-xs uppercase tracking-wider">{label}</span>
        <div className="flex bg-white/10 rounded-sm p-0.5">
          <button onClick={() => setView("qr")} data-testid={`${testid}-tab-qr`} className={`flex items-center gap-1 px-2.5 py-1 rounded-sm text-xs transition-colors ${view === "qr" ? "bg-brass text-ink" : "text-paper/70"}`}><QrCode size={13} /> QR</button>
          <button onClick={() => setView("link")} data-testid={`${testid}-tab-link`} className={`flex items-center gap-1 px-2.5 py-1 rounded-sm text-xs transition-colors ${view === "link" ? "bg-brass text-ink" : "text-paper/70"}`}><LinkIcon size={13} /> Link</button>
        </div>
      </div>

      {view === "qr" ? (
        <div className="flex flex-col items-center gap-3" id={`qr-${testid}`}>
          <div className="bg-white p-3 rounded-sm">
            <QRCodeCanvas value={url} size={168} level="M" fgColor="#122A43" />
          </div>
          <p className="text-paper/50 text-xs text-center">Scan untuk buka / Scan to open</p>
          <button onClick={downloadQR} className="flex items-center gap-1.5 text-paper/80 hover:text-brass text-xs transition-colors"><Download size={13} /> Muat turun QR / Download</button>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <div className="font-mono text-sm text-paper truncate flex-1 bg-white/5 px-3 py-2 rounded-sm" data-testid={`${testid}-url`}>{url}</div>
          <button onClick={copy} className="flex items-center gap-1.5 bg-brass text-ink font-semibold hover:bg-brass-hover px-3 py-2 rounded-sm text-sm transition-colors flex-shrink-0">
            {copied ? <Check size={15} /> : <Copy size={15} />} {copied ? "OK" : "Salin"}
          </button>
        </div>
      )}
    </div>
  );
}
